export const STOCK_LEVEL = {
    GOOD: "GOOD",
} as const;

export const AFTERPAY_MODAL_HOST = "https://static.afterpay.com/lightbox-desktop@3x.png";
export const CLEARPAY_MODAL_HOST = "https://static.afterpay.com/clearpay-lightbox-desktop@2x.png";

export type STOCK_LEVEL = typeof STOCK_LEVEL[keyof typeof STOCK_LEVEL];
